import Axios from 'src/utils/axiosConfig';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchUsersReport = createAsyncThunk('reports/users/all/', async (payload, { rejectWithValue }) => {
  try {
    const result = await Axios.get('reports/users/all');
    return result.data;
  } catch (error) {
    if (error.response) {
      return rejectWithValue(error.response.data);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});
